// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SupplierDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class SupplierApiClient extends BaseCRUDApiClient<SupplierDto> {
  baseUrl = this.config.apiEndpoint + '/supplier';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
